module.exports = __webpack_public_path__ + "img/cloudpods.ae158792.svg";